import { useState, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getGladOsOrigin } from 'src/presentation/components/pages/helpers';
import { toastError } from 'src/actions/toast';

const useIframeSrc = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const srcUrl = useMemo(() => `${getGladOsOrigin(window.location.origin)}/sidekick/hero-action-adapters`, []);

  const handleIframeLoad = useCallback(() => {
    setLoading(false);
    setError(null);
  }, []);

  const handleIframeError = useCallback(() => {
    setLoading(false);
    setError('Failed to load iframe content');
    dispatch(toastError('Unable to load content. Please try refreshing the page.'));
  }, [dispatch]);

  return {
    srcUrl,
    loading,
    error,
    handleIframeLoad,
    handleIframeError,
  };
};

export default useIframeSrc;
